module.exports = __webpack_public_path__ + "static/media/momo10.2b858aa3.jpg";